import { Div } from '@codesuma/baseline'
import style from './index.module.css'

// Slides — the strip the steps live in. Holds one at a time and animates the
// swap sideways. Only this strip moves; the heading above and the controls
// below stay where they are.
//
// The app is RTL, so going forward brings the next step in from the left and
// carries the old one off to the right. The classes are named for the role
// rather than the direction, so the rule stays readable in the stylesheet.

const DURATION = 280

type Direction = 'forward' | 'back' | 'none'
type Slide = ReturnType<typeof Div>

export const Slides = () => {
    const base = Div()
    base.addClass(style.stage)

    let current: Slide | null = null

    const show = (next: Slide, direction: Direction) => {
        const previous = current
        current = next

        next.addClass(style.slide)
        if (direction !== 'none') {
            next.addClass(direction === 'back' ? style.enterBack : style.enterForward)
        }
        base.append(next)

        // Force a layout pass so the off-screen start position lands on its own
        // frame. Without it the browser batches both class changes together and
        // the slide simply appears at rest.
        void next.el.offsetWidth
        next.removeClass(style.enterBack, style.enterForward)

        if (!previous) return
        if (direction === 'none') {
            previous.remove()
            return
        }
        previous.addClass(direction === 'back' ? style.leaveBack : style.leaveForward)
        setTimeout(() => previous.remove(), DURATION)
    }

    return Object.assign(base, { show })
}
